import { useContext, useState } from "react";
import styled from "styled-components";
import AppContext from "../../../../AppContext";
import ChevronLeft from "../../../../assets/icons/chevron-left.svg";
import ChevronRight from "../../../../assets/icons/chevron-right.svg";
import DownloadIcon from "../../../../assets/icons/download--icon.svg";
import TaskBarIcon from "../../../../assets/icons/task-bar.png";
import CloseBtn from "../../../../assets/icons/x-close.svg";
import EdgePopup from "../../../../assets/images/edge-popup.png";
import EdgeUlBarImg from "../../../../assets/images/edge-url-bar.png";
import LoginTopImg from "../../../../assets/images/footer-logologin.png";
import InsatlAlertImg from "../../../../assets/images/install-alert.png";
import SafariPopup from "../../../../assets/images/safari-popup.png";
import SafariTaskBar from "../../../../assets/images/safari-task-bar.png";
import SafariUlBarImg from "../../../../assets/images/safari-url-bar.png";
import YourBrandImage from "../../../../assets/images/your-brand.png";
import StoreGrid from "../../../../assets/images/about/StoreGrid.svg";
import SpeedUp from "../../../../assets/images/about/SpeedUp.svg";
import ReOrder from "../../../../assets/images/about/ReOrder.svg";
import WholeSale from "../../../../assets/images/about/WholeSale.svg";
import FullControl from "../../../../assets/images/about/FullControl.svg";
import Product from "../../../../assets/images/about/Product.svg";
import Checkbox from "../../checkbox/Checkbox";

//#region Styled Components
const StyledDownloadAndInstallAppDialog = styled.div`
    &.popup,
    &.popup * {
        box-sizing: border-box;
    }
    &.popup {
        background: #141922;
        border-radius: 20.33px;
        display: flex;
        flex-direction: column;
        gap: 40.67px;
        align-items: center;
        justify-content: flex-start;
        height: 885px;
        position: sticky;
        overflow: hidden;
        backdrop-filter: blur(63.55px);
        height: 85vh;
        overflow-y: auto;
        max-height: 892px;
    }
    .frame-1000011177 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-427319123 {
        background: #29313f;
        padding: 68.54px 40.67px 40.67px 40.67px;
        display: flex;
        flex-direction: column;
        gap: 20.33px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        width: 659px;
        position: relative;
        height: 885px;
        overflow: hidden;
    }
    .frame-295922901 {
        flex-shrink: 0;
        width: 960.12px;
        height: 540.02px;
        position: absolute;
        left: 184.08px;
        top: 385px;
        box-shadow: 0px 6.39px 294.06px 0px rgba(0, 0, 0, 0.72);
        transform-origin: 0 0;
        transform: rotate(13.939deg) scale(1, 1);
        border-radius: 19.06px;
    }
    .quick-message-32 {
        border-radius: 19.06px;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.08);
        border-width: 7.15px;
        width: 960.08px;
        height: 540.05px;
        position: absolute;
        left: 50%;
        translate: -50%;
        top: 0px;
        transform-origin: 0 0;
        transform: rotate(0deg) scale(1, 1);
        backdrop-filter: blur(11.91px);
        object-fit: cover;
        aspect-ratio: 960.08/540.05;
    }
    .experience-b-ostage-b-better-as-a-web-app {
        color: #ffffff;
        text-align: left;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 44px;
        letter-spacing: -0.015em;
        font-weight: 700;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-1000011056 {
        display: flex;
        flex-direction: column;
        gap: 20.33px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .table-check-box {
        display: flex;
        flex-direction: row;
        gap: 10.17px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .text {
        color: #d1d1d1;
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 25.42px;
        font-weight: 400;
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-1000011375 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .checkbox-label {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }

    .text2 {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    .frame-427319151 {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 0;
        width: 787.5px;
        height: 884.95px;
        position: relative;
    }
    .frame-1000011042 {
        background: linear-gradient(rgb(211 126 0 / 22%) 0%, rgba(12, 12, 12, 0.2) 20%),
            linear-gradient(to left, rgb(20, 25, 34), rgb(20, 25, 34));
        padding: 68.54px 32px 39.17px 32px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        align-self: stretch;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .frame-1000011045 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011186 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011178 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .b-ostage-b-2 {
        flex-shrink: 0;
        width: 159.12px;
        height: 44.06px;
        position: relative;
        object-fit: cover;
    }
    .text3 {
        color: #d1d1d1;
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 25.42px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-1000011179 {
        display: flex;
        flex-direction: column;
        gap: 29.38px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011180 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .text4 {
        background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(153, 153, 153, 1) 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-align: center;
        font-family: "Roboto-SemiBold", sans-serif;
        font-size: 30px;
        font-weight: 600;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .frame-1000011376 {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011389 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011378 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        transform-origin: 0 0;
    }
    .frame-1000011388 {
        background: var(--backgrounds-and-lines-n-300, #1a222d);
        border-radius: 9999px;
        padding: 4px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        cursor: pointer;
    }
    .chevron-right {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-1000011377 {
        display: flex;
        flex-direction: column;
        gap: 56px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex: 1;
        position: relative;
    }
    .frame-1000011185 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .text5 {
        text-align: center;
        font-family: "-", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .text-5-span {
        color: #ff9900;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-5-span2 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
    .group-16 {
        flex-shrink: 0;
        width: 432.47px;
        height: 55.8px;
        position: static;
    }
    .group-15 {
        width: 432.47px;
        height: 55.8px;
        position: static;
    }
    .group-14 {
        width: 432.47px;
        height: 55.8px;
        position: static;
    }
    .rectangle-13 {
        background: #363e4a;
        border-radius: 23248.99px;
        width: 432.47px;
        height: 55.8px;
        position: absolute;
        left: 105.51px;
        top: 40px;
    }
    .text6 {
        color: rgba(209, 209, 209, 0.3);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 18.60105323791504px;
        line-height: 27.9px;
        font-weight: 400;
        position: absolute;
        left: 129.95px;
        top: 54.63px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .download-logo {
        border-radius: 23248.99px;
        display: flex;
        flex-direction: column;
        gap: 23.25px;
        align-items: center;
        justify-content: center;
        width: 99.98px;
        height: 46.5px;
        position: absolute;
        left: 432.19px;
        top: 44.65px;
        overflow: visible;
    }
    .frame-1000011187 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .text-5-span3 {
        color: #ff9900;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-5-span4 {
        color: #d1d1d1;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-5-span5 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
    .text-5-span6 {
        color: #ff9900;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-5-span7 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
    .image-1 {
        border-radius: 10px;
        flex-shrink: 0;
        width: 444px;
        height: 177px;
        position: relative;
        object-fit: cover;
        aspect-ratio: 444/177;
    }
    .frame-1000011188 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .text-5-span8 {
        color: #ff9900;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-5-span9 {
        color: #d1d1d1;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
    }
    .text-5-span10 {
        color: #d1d1d1;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
    }
    .taskbar {
        background: linear-gradient(
            90deg,
            rgba(19, 23, 30, 0.96) 0%,
            rgba(32, 32, 32, 0.96) 48.500001430511475%,
            rgba(19, 23, 30, 0.96) 99.00000095367432%
        );
        border-radius: 20px;
        flex-shrink: 0;
        width: 587px;
        height: 48px;
        position: relative;
        backdrop-filter: var(--blurs-blur-acrylic-backdrop-filter, blur(30px));
    }
    .app-icons {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 50%;
        translate: -50% -50%;
        top: 50%;
        width: 100%;
    }

    .app-icons img {
        width: 100%;
    }

    .frame-1000011279 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .chevron-right2 {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-1000011392 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-1000011391 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .active {
        background: #ff9900 !important;
    }
    .ellipse-3 {
        background: var(--backgrounds-and-lines-n-200, #262e3e);
        border-radius: 50%;
        flex-shrink: 0;
        width: 14px;
        height: 14px;
        cursor: pointer;
        position: relative;
    }
    .disabled {
        opacity: 0.3;
        cursor: not-allowed;
    }
    .x-close {
        flex-shrink: 0;
        width: 45px;
        height: 45px;
        position: absolute;
        right: 15.5px;
        top: 16px;
        overflow: visible;
        aspect-ratio: 1;
        cursor: pointer;
    }
    .frame-1000011190 {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
    }
    .frame-1000011190 .image-7 {
        width: 283px;
    }

    .frame-1000011189.edge {
        display: flex;
        flex-direction: column;
        gap: 16px;
    }

    .edge .group-16 {
        flex-shrink: 0;
        width: 100%;
        height: 55.8px;
        position: relative;

        display: flex;
        justify-content: center;
        align-items: center;
    }
    .edge .group-15 {
        width: 432.47px;
        height: 55.8px;
        background-color: #292929;
        border-radius: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 25px;
    }
    .edge .group-14 {
        width: 432.47px;
        height: 55.8px;
        position: static;
    }
    .edge .rectangle-13 {
        background: #292929;
        border-radius: 23248.99px;
        width: 432.47px;
        height: 55.8px;
        position: absolute;
        left: 105.51px;
        top: 40px;
    }
    .edge .image-6 {
        width: 164px;
        height: 34px;
        overflow: hidden; /* Ensures image stays inside the circle */
        display: flex;
        justify-content: center;
        right: 94px;
        position: absolute;
    }
    .edge .text2 {
        color: rgba(209, 209, 209, 0.3);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 18px;
        line-height: 27.9px;
        font-weight: 400;
        position: absolute;
    }
    .highlight-circle {
        height: 65px;
        width: 65px;
        border: 4px solid #ff9900;
        border-radius: 50px;
        position: absolute;
        right: 175px;
    }
    .image-6.safari {
        width: 190px;
        height: 29px;
        right: 56px;
    }
    .group-15.safari {
        background-color: rgb(54 54 54) !important;
    }
    .highlight-circle.safari {
        right: 150px;
    }
    .frame-1000011377.safari {
        gap: 25px;
    }
    .safari-taskbar img {
        width: 440px;
        height: 167px;
    }

    .main-wrapper-about-app {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        gap: 16px;
    }
    .group-with-img-text {
        display: flex;
        flex-direction: column;
        width: 194px;
        gap: 10px;
        height: 191px;
        justify-content: center;
        align-items: center;
    }
    .about-sub-text {
        line-height: 18px;
        font-size: 14px;
        text-align: left;
    }
    .sub-heading {
        padding: 0px 45px;
    }
`;
//#endregion

export default function DownloadAndInstallAppDialog({ browser, onHideDialog }) {
    //#region VARS
    const [isChecked, setIsChecked] = useState(false);
    const { setShowDownloadAppPopup, firstLoginDone } = useContext(AppContext);
    const [page, setPage] = useState(1); // 1: Install App, 2: About the App
    //#endregion

    //#region HANDLERS
    const closePopup = () => {
        setShowDownloadAppPopup(false);
        if (isChecked) {
            onHideDialog(true);
        } else {
            onHideDialog(false);
        }
    };

    const handleCheckboxChange = () => {
        const newCheckedState = !isChecked;
        setIsChecked(newCheckedState);
    };
    //#endregion

    return (
        <StyledDownloadAndInstallAppDialog className="popup">
            <div className="frame-1000011177">
                <div className="frame-427319123">
                    <div className="frame-295922901">
                        <img className="quick-message-32" src={YourBrandImage} alt="Your Brand" />
                    </div>
                    <div className="experience-b-ostage-b-better-as-a-web-app">
                        Experience BOstageR
                        <br />
                        better as a web app!
                    </div>
                    <div className="frame-1000011056">
                        <div className="table-check-box">
                            <div className="text">
                                For a smoother, faster, and more focused experience,
                                <br />
                                install BOstageR directly on your device.
                            </div>
                        </div>
                    </div>
                    <div className="frame-1000011375">
                        {firstLoginDone && (
                            <div className="checkbox-label">
                                <Checkbox isChecked={isChecked} onCheckboxClick={handleCheckboxChange} />
                                <div className="text2">Don&#039;t show this anymore, I downloaded the app.</div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="frame-427319151">
                    <div className="frame-1000011042">
                        <div className="frame-1000011045">
                            <div className="frame-1000011186">
                                <div className="frame-1000011178">
                                    <img className="b-ostage-b-2" src={LoginTopImg} alt="" />
                                    <div className="text3">the BOtag B2B platform for Retailers</div>
                                </div>

                                <div className="frame-1000011179">
                                    <div className="frame-1000011180">
                                        <div className="text4">
                                            {page === 1
                                                ? "Install the web app in 3 easy steps!"
                                                : "What's in it for you?"}
                                        </div>
                                        {page === 2 && (
                                            <div className="sub-heading">
                                                Seamlessly connecting stores and brands, BOtag automates product
                                                management, fulfillment, and sales, so stores sell more with full
                                                support from suppliers.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {page === 1 ? (
                                <>
                                    {browser === "edge" && <EdgeUserGuide setPage={setPage} page={page} />}
                                    {browser === "chrome" && <ChromeUserGuide setPage={setPage} page={page} />}
                                    {browser === "safari" && <SafariUserGuide setPage={setPage} page={page} />}
                                </>
                            ) : (
                                <AboutTheApp setPage={setPage} page={page} />
                            )}
                            <div className="frame-1000011376">
                                <div className="frame-1000011392">
                                    <div className="frame-1000011391">
                                        <div className={`ellipse-3 ${page === 1 ? "active" : ""}`}></div>
                                        <div className={`ellipse-3 ${page === 2 ? "active" : ""}`}></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <img className="x-close" src={CloseBtn} alt="" onClick={closePopup} />
        </StyledDownloadAndInstallAppDialog>
    );
}

//#region SMALL COMPONENT
const NavigationArrow = ({ element, page, setPage }) => {
    return (
        <div className="frame-1000011389">
            <div className="frame-1000011378" onClick={() => setPage(1)}>
                <div className={`frame-1000011388 ${page === 1 ? "disabled" : ""}`}>
                    <img className="chevron-right" src={ChevronLeft} alt="ChevronLeft" />
                </div>
            </div>
            {element}
            <div className="frame-1000011279" onClick={() => setPage(2)}>
                <div className={`frame-1000011388 ${page === 2 ? "disabled" : ""}`}>
                    <img className="chevron-right2" src={ChevronRight} alt="ChevronRight" />
                </div>
            </div>
        </div>
    );
};
const ChromeUserGuide = ({ page, setPage }) => {
    return (
        <NavigationArrow
            page={page}
            setPage={setPage}
            element={
                <div className="frame-1000011377">
                    <div className="frame-1000011185">
                        <div className="text5">
                            <span>
                                <span className="text-5-span">Step 1: </span>
                                <span className="text-5-span2">
                                    On your browser, click this icon on the right corner of the address bar.
                                </span>
                            </span>
                        </div>
                        <div className="group-16">
                            <div className="group-15">
                                <div className="group-14">
                                    <div className="rectangle-13"></div>
                                    <div className="text6">https://retailer.bostages.com</div>
                                </div>
                                <img className="download-logo" src={DownloadIcon} alt="DownloadIcon" />
                            </div>
                        </div>
                    </div>
                    <div className="frame-1000011187">
                        <div className="text5">
                            <span>
                                <span className="text-5-span3">Step 2: </span>
                                <span className="text-5-span4"></span>
                                <span className="text-5-span5">After you click, a pop-up will open and click on “</span>
                                <span className="text-5-span6">Install</span>
                                <span className="text-5-span7">”.</span>
                            </span>
                        </div>
                        <img className="image-1" src={InsatlAlertImg} alt="InsatlAlertImg" />
                    </div>
                    <div className="frame-1000011188">
                        <div className="text5">
                            <span>
                                <span className="text-5-span8">Step 3: </span>
                                <span className="text-5-span9"></span>
                                <span className="text-5-span10">
                                    When the app was installed, pin it on your taskbar and enjoy!
                                </span>
                            </span>
                        </div>
                        <div className="taskbar">
                            <div className="app-icons">
                                <img src={TaskBarIcon} alt="TaskBarIcon" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

const EdgeUserGuide = ({ page, setPage }) => {
    return (
        <NavigationArrow
            page={page}
            setPage={setPage}
            element={
                <div className="frame-1000011377">
                    <div className="frame-1000011189 edge">
                        <div className="text">
                            <span>
                                <span className="text-5-span3">Step 1: </span>
                                <span className="text-span2">
                                    On your Edge browser, click this icon on the right corner of the address bar
                                </span>
                            </span>
                        </div>
                        <div className="group-16">
                            <div className="group-15">
                                <div className="text2">https://retailer.bostages.com</div>
                                <div className="image-6">
                                    <img src={EdgeUlBarImg} alt="DownloadIcon" />
                                </div>
                                <div className="highlight-circle"></div>
                            </div>
                        </div>
                    </div>
                    <div className="frame-1000011190">
                        <div className="text">
                            <span>
                                <span className="text-5-span3">Step 2: </span>
                                <span className="text-span4"></span>
                                <span className="text-span5">Click on “</span>
                                <span className="text-5-span3">Install</span>
                                <span className="text-span7">”</span>
                            </span>
                        </div>
                        <img className="image-7" src={EdgePopup} alt="EdgePopup" />
                    </div>
                    <div className="frame-1000011191">
                        <div className="frame-1000011188">
                            <div className="text">
                                <span>
                                    <span className="text-5-span3">Step 3: </span>
                                    <span className="text-span9"></span>
                                    <span className="text-span10">
                                        When the app was installed, pin it on your taskbar and enjoy!
                                    </span>
                                </span>
                            </div>
                            <div className="taskbar">
                                <div className="app-icons">
                                    <img src={TaskBarIcon} alt="TaskBarIcon" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

const SafariUserGuide = ({ page, setPage }) => {
    return (
        <NavigationArrow
            page={page}
            setPage={setPage}
            element={
                <div className="frame-1000011377 safari">
                    <div className="frame-1000011189 edge">
                        <div className="text">
                            <span>
                                <span className="text-5-span3">Step 1: </span>
                                <span className="text-span2">
                                    On your safari browser, click this icon on the right corner of the toolbar
                                </span>
                            </span>
                        </div>
                        <div className="group-16">
                            <div className="group-15 safari">
                                <div className="text2">https://retailer.bostages.com</div>
                                <div className="image-6 safari">
                                    <img src={SafariUlBarImg} alt="DownloadIcon" />
                                </div>
                                <div className="highlight-circle safari"></div>
                            </div>
                        </div>
                    </div>
                    <div className="frame-1000011190">
                        <div className="text">
                            <span>
                                <span className="text-5-span3">Step 2: </span>
                                <span className="text-span4"></span>
                                <span className="text-span5">Click on “</span>
                                <span className="text-5-span3">Add to Dock</span>
                                <span className="text-span7">”</span>
                            </span>
                        </div>
                        <img className="image-7" src={SafariPopup} alt="EdgePopup" />
                    </div>
                    <div className="frame-1000011191">
                        <div className="frame-1000011188">
                            <div className="text">
                                <span>
                                    <span className="text-5-span3">Step 3: </span>
                                    <span className="text-span9"></span>
                                    <span className="text-span10">
                                        Click “<span className="text-5-span3">Add</span>” to launch and experience
                                        BOstageR in an immersive way!
                                    </span>
                                </span>
                            </div>
                            <div className="safari-taskbar">
                                <img src={SafariTaskBar} alt="TaskBarIcon" />
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};

const AboutTheApp = ({ page, setPage }) => {
    return (
        <NavigationArrow
            page={page}
            setPage={setPage}
            element={
                <div className="frame-1000011377" style={{ height: "417.5px" }}>
                    <div className="main-wrapper-about-app">
                        <div className="group-with-img-text">
                            <div className="about-img">
                                <img src={StoreGrid} alt="AboutTheAppImg" />
                            </div>
                            <div className="about-sub-text">Create a digital connection with the brands your sell</div>
                        </div>
                        <div className="group-with-img-text">
                            <div className="about-img">
                                <img src={SpeedUp} alt="AboutTheAppImg" />
                            </div>
                            <div className="about-sub-text">Speed up stock rotation of products in stores</div>
                        </div>
                        <div className="group-with-img-text">
                            <div className="about-img">
                                <img src={ReOrder} alt="AboutTheAppImg" />
                            </div>
                            <div className="about-sub-text">Get reorders suggestions based on stock performance</div>
                        </div>
                        <div className="group-with-img-text">
                            <div className="about-img">
                                <img src={WholeSale} alt="AboutTheAppImg" />
                            </div>
                            <div className="about-sub-text">Allow suppliers to follow your stock for extra support</div>
                        </div>
                        <div className="group-with-img-text">
                            <div className="about-img">
                                <img src={FullControl} alt="AboutTheAppImg" />
                            </div>
                            <div className="about-sub-text">
                                Get full control of the digital relationship with Brands
                            </div>
                        </div>
                        <div className="group-with-img-text">
                            <div className="about-img">
                                <img src={Product} alt="AboutTheAppImg" />
                            </div>
                            <div className="about-sub-text">Product master data auto-transfer to your stores</div>
                        </div>
                    </div>
                </div>
            }
        />
    );
};
